import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserTypes } from "api";

export interface ChatContact2 {
    userId: number;
    fullName: string;
    profileImage: string;
    bgColor: string;
    foreColor: string;
    abbrName: string;
    isFavorite: boolean;
    lastChatText: string;
    lastChatTime: string;
    unreadCount?: number;
    unreadTagMe?: number;
    companyId?: number;
    isSaleCorrect?: boolean;
    isCsCorrect?: boolean;
}

export interface ChatContactState2 {
    chatContacts: ChatContact2[];
    currentPage: number;
    nextPage: number;
    // totalPages: number;
    // totalRecords: number;
    hasMore: boolean;
    loading: boolean;
    filter: string;
    errorMsg: string;
    // total: number;
    // loading: boolean;
    // error: string | null;
    // page: number;

    chatContactsSup: ChatContact2[];
    currentPageSup: number;
    nextPageSup: number;
    hasMoreSup: boolean;
    loadingSup: boolean;
    filterSup: string;
    errorMsgSup: string;
}

const initialState: ChatContactState2 = {
    chatContacts: [],
    currentPage: 1,
    nextPage: 1,
    // totalPages: 0,
    // totalRecords: 0,
    hasMore: false,
    loading: false,
    filter: "",
    errorMsg: "",

    chatContactsSup: [],
    currentPageSup: 1,
    nextPageSup: 1,
    hasMoreSup: false,
    loadingSup: false,
    filterSup: "",
    errorMsgSup: "",
}
const chatContactSlice = createSlice({
    name: "chatContacts",
    initialState,
    reducers: {

        fetchChatContactsRequest(
            state,
            action: PayloadAction<{
                page: number; filter: string, isFetchNext: boolean,
                filterUnread?: boolean | null, filterPersonUnRead?: boolean | null, filterNoActivity?: boolean | null, filterSaleIds?: number[], filterCsIds?: number[], filterProvinceIds?: number[], groupType: UserTypes,
                currentSelectedChatId: any, companyType?: string
            }>
        ) {
            // console.log('fetchChatContactsRequest:', action.payload);
            if (action.payload.groupType == UserTypes.Group) {
                state.loading = true;
                state.errorMsg = "";
                state.filter = action.payload.filter;
            } else if (action.payload.groupType == UserTypes.GroupSupplier) {
                state.loadingSup = true;
                state.errorMsgSup = "";
                state.filterSup = action.payload.filter;
            }
            // state.error = null;
        },

        fetchChatContactsSuccess(
            state,
            action: PayloadAction<{ chatContacts: ChatContact2[]; currentPage: number; nextPage: number, hasMore: boolean, isFetchNext: boolean, groupType: UserTypes }>
        ) {
            const isFirstFetch = !action.payload.isFetchNext;
            // console.log('fetch chat contact success : ',{isFirstFetch});

            //state.chatContacts = [...state.chatContacts, ...action.payload.chatContacts]; //this code if save react code, data will duplicate

            // Extract existing userIds from state.chatContacts
            const existingUserIds = new Set(state.chatContacts.map(contact => contact.userId));

            // Filter out duplicate entries from the payload
            const newContacts = isFirstFetch ? action.payload.chatContacts : action.payload.chatContacts.filter(contact => !existingUserIds.has(contact.userId));

            if (action.payload.groupType == UserTypes.Group) {
                // Append only unique contacts to the state
                state.chatContacts = isFirstFetch ? [...newContacts] : [...state.chatContacts, ...newContacts];

                // state.totalPages = action.payload.totalPages;
                state.currentPage = action.payload.currentPage;
                state.nextPage = action.payload.nextPage;
                state.hasMore = action.payload.hasMore;
                state.loading = false;
                state.errorMsg = "";
            } else if (action.payload.groupType == UserTypes.GroupSupplier) {
                state.chatContactsSup = isFirstFetch ? [...newContacts] : [...state.chatContactsSup, ...newContacts];
                state.currentPageSup = action.payload.currentPage;
                state.nextPageSup = action.payload.nextPage;
                state.hasMoreSup = action.payload.hasMore;
                state.loadingSup = false;
                state.errorMsgSup = "";
            }
        },
        fetchChatContactsFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.errorMsg = action.payload;
        },
        swapChatRooms: (state, action: PayloadAction<{ index1: number; index2: number }>) => {
            const { index1, index2 } = action.payload;

            // Swap items using Immer's draft state
            const temp = state.chatContacts[index1];
            state.chatContacts[index1] = state.chatContacts[index2];
            state.chatContacts[index2] = temp;
        },
        swapChatToTop: (state, action: PayloadAction<{ groupType: UserTypes, newMsg: ChatContact2 }>) => {
            // console.log('swapChatToTop:', action.payload);
            const { groupType, newMsg } = action.payload;

            if (groupType == UserTypes.Group) {
                // Find the index of the contact with the same userId
                const existingIndex = state.chatContacts.findIndex(
                    contact => contact.userId === newMsg.userId
                );
                // console.log('swap chat to top: ' + existingIndex);
                if (existingIndex !== 0) { // not already on top
                    if (existingIndex !== -1) {
                        // Move the existing contact to the top by swapping
                        const [existingContact] = state.chatContacts.splice(existingIndex, 1);
                        state.chatContacts.unshift(existingContact);
                    } else {
                        // If not found, insert the newMsg at the top
                        state.chatContacts.unshift(newMsg);
                    }
                }
            } else if (groupType == UserTypes.GroupSupplier) {
                // Find the index of the contact with the same userId
                const existingIndex = state.chatContactsSup.findIndex(
                    contact => contact.userId === newMsg.userId
                );
                // console.log('swap chat to top: ' + existingIndex);
                if (existingIndex !== 0) { // not already on top
                    if (existingIndex !== -1) {
                        // Move the existing contact to the top by swapping
                        const [existingContact] = state.chatContactsSup.splice(existingIndex, 1);
                        state.chatContactsSup.unshift(existingContact);
                    } else {
                        // If not found, insert the newMsg at the top
                        state.chatContactsSup.unshift(newMsg);
                    }
                }
            }
        },
        markReadAll: (state, action: PayloadAction<{ userOrGroupId: number }>) => {
            const { userOrGroupId } = action.payload;
            const chatContact = state.chatContacts.find(contact => contact.userId === userOrGroupId);
            if (chatContact) chatContact.unreadCount = 0;
        },
        updateUnreadCount: (
            state,
            action: PayloadAction<{ userId: number, unreadCount: number, unreadTagMe: number, lastChatText: string, lastChatTime: string }>
        ) => {
            // console.log('xxx');
            const { userId, unreadCount, unreadTagMe, lastChatText, lastChatTime } = action.payload;

            // Find the chat contact by userId
            const chatContact = state.chatContacts.find(contact => contact.userId === userId);

            if (chatContact) {
                // Update the properties if the contact is found
                chatContact.unreadCount = unreadCount;
                chatContact.unreadTagMe = unreadTagMe;
                if (lastChatText && lastChatText != "") chatContact.lastChatText = lastChatText;
                if (lastChatTime && lastChatTime != "") chatContact.lastChatTime = lastChatTime;
            } else { // 20250915 not found group chat in customer mode, then find in supplier mode
                const chatContactsSup = state.chatContactsSup.find(contact => contact.userId === userId);
                if (chatContactsSup) {
                    chatContactsSup.unreadCount = unreadCount;
                    chatContactsSup.unreadTagMe = unreadTagMe;
                    if (lastChatText && lastChatText != "") chatContactsSup.lastChatText = lastChatText;
                    if (lastChatTime && lastChatTime != "") chatContactsSup.lastChatTime = lastChatTime;
                }
            }
        },

        // Use when user map chat room with customer id from dconnect
        setCustomerId: (
            state,
            action: PayloadAction<{ userOrGroupId: number, companyId: number | undefined }>
        ) => {
            const { userOrGroupId, companyId } = action.payload;

            // find group
            const chatContact = state.chatContacts.find(contact => contact.userId === userOrGroupId);
            if (chatContact) {
                chatContact.companyId = companyId;
            }
        },

        changeGroupFullName: (
            state,
            action: PayloadAction<{ groupId: any, fullName: any }>
        ) => {
            const { groupId, fullName } = action.payload;
            // find group
            const chatContact = state.chatContacts.find(contact => contact.userId === groupId);
            if (chatContact) {
                chatContact.fullName = fullName;
            }

        },


    },
});

export const {
    fetchChatContactsRequest,
    fetchChatContactsSuccess,
    fetchChatContactsFailure,
    swapChatRooms,
    markReadAll,
    updateUnreadCount,
    swapChatToTop,
    setCustomerId,
    changeGroupFullName
} = chatContactSlice.actions;

export default chatContactSlice.reducer;